(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultReportDialogController', ResultReportDialogController);

    ResultReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ResultReport', 'Result'];

    function ResultReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ResultReport, Result) {
        var vm = this;

        vm.resultReport = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.results = Result.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resultReport.id !== null) {
                ResultReport.update(vm.resultReport, onSaveSuccess, onSaveError);
            } else {
                ResultReport.save(vm.resultReport, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:resultReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setReportPdf = function ($file, resultReport) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        resultReport.reportPdf = base64Data;
                        resultReport.reportPdfContentType = $file.type;
                    });
                });
            }
        };

    }
})();
